import { Button, Drawer, Form, Image, Input, Select, Space, Tabs, Tooltip } from 'antd';

const ContentDetailDrawer = ({
  open,
  onClose,
  contentDetail,
  detailLoading,
  activeTab,
  setActiveTab,
  detailForm,
  formatDateTime,
  fixMojibakeUtf8,
  normalizeTagsArray,
  contentDeliveryPlatformOptions,
  onSave,
  onReset,
  isVideoType,
  isVideoUrl,
  isImageUrl,
}) => (
  <Drawer
    title="内容详情"
    placement="right"
    width={600}
    onClose={onClose}
    open={open}
    loading={detailLoading}
    mask
    maskStyle={{ backdropFilter: 'none', WebkitBackdropFilter: 'none' }}
  >
    {contentDetail && (
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'preview',
            label: '内容预览',
            children: (
              <div style={{ padding: '16px 0' }}>
                <div style={{ marginBottom: 24 }}>
                  <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>标题</h3>
                  <p style={{ fontSize: 16, color: '#333' }}>{contentDetail.title}</p>
                </div>
                <div style={{ marginBottom: 24 }}>
                  <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>内容简介</h3>
                  <p style={{ fontSize: 14, color: '#666', lineHeight: 1.8 }}>{contentDetail.summary || '-'}</p>
                </div>
                {contentDetail.media_urls && contentDetail.media_urls.length > 0 && (() => {
                  const mediaUrls = Array.isArray(contentDetail.media_urls) ? contentDetail.media_urls : [];
                  const treatAllAsVideo = isVideoType(contentDetail.content_type);
                  const videoUrls = treatAllAsVideo ? mediaUrls : mediaUrls.filter((u) => isVideoUrl(u));
                  const imageUrls = treatAllAsVideo ? [] : mediaUrls.filter((u) => isImageUrl(u));
                  const otherUrls = treatAllAsVideo
                    ? []
                    : mediaUrls.filter((u) => !isVideoUrl(u) && !isImageUrl(u));

                  const imageUrlsFinal = !treatAllAsVideo && imageUrls.length === 0 && otherUrls.length > 0
                    ? otherUrls
                    : imageUrls;
                  const otherUrlsFinal = !treatAllAsVideo && imageUrls.length === 0 ? [] : otherUrls;

                  if (videoUrls.length === 0 && imageUrlsFinal.length === 0 && otherUrlsFinal.length === 0) return null;

                  return (
                    <div style={{ marginBottom: 24 }}>
                      <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>
                        {videoUrls.length > 0 && imageUrlsFinal.length > 0 ? '媒体文件' : (videoUrls.length > 0 ? '视频预览' : '图片预览')}
                      </h3>

                      {imageUrlsFinal.length > 0 && (
                        <Image.PreviewGroup>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                            {imageUrlsFinal.map((url, index) => (
                              <Image
                                key={`img_${index}`}
                                src={url}
                                alt={`图片 ${index + 1}`}
                                style={{
                                  width: 160,
                                  height: 160,
                                  objectFit: 'cover',
                                  borderRadius: 8,
                                  border: '1px solid #f0f0f0',
                                }}
                                preview={{ mask: '预览' }}
                              />
                            ))}
                          </div>
                        </Image.PreviewGroup>
                      )}

                      {videoUrls.length > 0 && (
                        <div style={{ marginTop: imageUrlsFinal.length > 0 ? 16 : 0 }}>
                          {videoUrls.map((url, index) => (
                            <video
                              key={`vid_${index}`}
                              src={url}
                              controls
                              style={{ width: '100%', maxWidth: 600, marginBottom: 16, borderRadius: 8, backgroundColor: '#000' }}
                            />
                          ))}
                        </div>
                      )}

                      {otherUrlsFinal.length > 0 && (
                        <div style={{ marginTop: 8 }}>
                          {otherUrlsFinal.map((url, index) => (
                            <div
                              key={`other_${index}`}
                              style={{
                                padding: '10px 12px',
                                background: '#f5f5f5',
                                borderRadius: 8,
                                wordBreak: 'break-all',
                                marginBottom: 8,
                              }}
                            >
                              <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>
                                {url}
                              </a>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })()}
                {(contentDetail.body || contentDetail.content) && (
                  <div style={{ marginBottom: 24 }}>
                    <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>文字内容</h3>
                    {(() => {
                      const body = contentDetail.body ?? contentDetail.content ?? '';
                      if (!body) return null;
                      const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(body);
                      if (looksLikeHtml) {
                        return (
                          <div
                            style={{
                              border: '1px solid #f0f0f0',
                              borderRadius: 8,
                              background: '#fff',
                              overflow: 'hidden',
                              maxHeight: 420,
                            }}
                          >
                            <iframe
                              title="content-html-preview"
                              srcDoc={String(body)}
                              sandbox=""
                              style={{
                                display: 'block',
                                width: '100%',
                                height: 420,
                                border: 0,
                              }}
                            />
                          </div>
                        );
                      }
                      return (
                        <p style={{ fontSize: 14, color: '#666', lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>
                          {body}
                        </p>
                      );
                    })()}
                  </div>
                )}
              </div>
            ),
          },
          {
            key: 'edit',
            label: '内容编辑',
            children: (
              <Form
                form={detailForm}
                layout="horizontal"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                style={{ padding: '16px 0' }}
              >
                {contentDetail.cover_image && (
                  <Form.Item label="封面图">
                    <Image
                      src={contentDetail.cover_image}
                      alt="封面图"
                      style={{ maxWidth: 300, maxHeight: 200 }}
                    />
                  </Form.Item>
                )}
                <Form.Item
                  label="标题"
                  name="title"
                  rules={[{ required: true, message: '请输入标题' }]}
                >
                  <Input placeholder="请输入标题" />
                </Form.Item>
                <Form.Item label="发布时间">
                  <span>{formatDateTime(contentDetail.created_at)}</span>
                </Form.Item>
                <Form.Item
                  label="内容简介"
                  name="summary"
                >
                  <Input.TextArea rows={4} placeholder="请输入内容简介" />
                </Form.Item>
                <Form.Item
                  label="内容"
                  name="body"
                >
                  <Input.TextArea rows={6} placeholder="请输入内容" />
                </Form.Item>
                <Form.Item label="内容长度">
                  <span>{contentDetail.word_count || 0} 字</span>
                </Form.Item>
                <Form.Item label="创作者">
                  <span>{fixMojibakeUtf8(contentDetail.author) || '-'}</span>
                </Form.Item>
                <Form.Item
                  label="创作者ID(openid)"
                  name="creator_user_id"
                >
                  <Input placeholder="请输入创作者openid" />
                </Form.Item>
                {contentDetail.media_urls && contentDetail.media_urls.length > 0 && (
                  <Form.Item label="内容链接">
                    <div>
                      {contentDetail.media_urls.map((url, index) => (
                        <a key={index} href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'block', marginBottom: 8 }}>
                          {url}
                        </a>
                      ))}
                    </div>
                  </Form.Item>
                )}
                <Form.Item label="内容大小">
                  <span>{contentDetail.size_bytes ? `${(contentDetail.size_bytes / 1024 / 1024).toFixed(2)} MB` : '-'}</span>
                </Form.Item>
                {contentDetail.duration_seconds && (
                  <Form.Item label="视频时长">
                    <span>{contentDetail.duration_seconds} 秒</span>
                  </Form.Item>
                )}
                <Form.Item
                  label="标签"
                  name="tags"
                >
                  <Select
                    mode="tags"
                    placeholder="回车添加标签"
                    tokenSeparators={[',', '，']}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
                <Form.Item
                  label="内容来源"
                  name="source"
                >
                  <Select
                    style={{ width: '100%' }}
                    allowClear
                    options={[
                      { label: '自建', value: '自建' },
                      { label: '抓取', value: '抓取' },
                      { label: 'AI生成', value: 'AI生成' },
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  label="内容类型"
                  name="content_type"
                >
                  <Select
                    style={{ width: '100%' }}
                    allowClear
                    options={[
                      { label: '视频', value: '视频' },
                      { label: '图文', value: '图文' },
                      { label: '笔记', value: '笔记' },
                    ]}
                  />
                </Form.Item>
                <Form.Item label="一级分类" name="primary_category">
                  <Input placeholder="请输入一级分类" />
                </Form.Item>
                <Form.Item label="二级分类" name="secondary_category">
                  <Input placeholder="请输入二级分类" />
                </Form.Item>
                <Form.Item label="风险状态" name="risk_flag">
                  <Select style={{ width: '100%' }} allowClear options={[{ label: '是', value: true }, { label: '否', value: false }]} />
                </Form.Item>
                <Form.Item label="是否需要人工审核" name="manual_review_required">
                  <Select style={{ width: '100%' }} allowClear options={[{ label: '是', value: true }, { label: '否', value: false }]} />
                </Form.Item>
                <Form.Item label="是否审核" name="is_manual_reviewed">
                  <Select style={{ width: '100%' }} allowClear options={[{ label: '是', value: true }, { label: '否', value: false }]} />
                </Form.Item>
                <Form.Item label="内容状态" name="status">
                  <Select style={{ width: '100%' }} allowClear options={[{ label: '待发布', value: '待发布' }, { label: '已发布', value: '已发布' }, { label: '作废', value: '作废' }]} />
                </Form.Item>
                <Form.Item label="投递平台" name="available_platforms">
                  <Select mode="multiple" allowClear style={{ width: '100%' }} options={contentDeliveryPlatformOptions} />
                </Form.Item>
                <Form.Item>
                  <Space>
                    <Button type="primary" onClick={onSave}>保存</Button>
                    <Button onClick={onReset}>重置</Button>
                  </Space>
                </Form.Item>
              </Form>
            ),
          },
        ]}
      />
    )}
  </Drawer>
);

export default ContentDetailDrawer;
